import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  selectedValue: any;
  selectedPropertyName:any;
  hideCheckBox:boolean;
  title?: string;
}

@Component({
    selector: 'app-common-popup-search',
    templateUrl: './common-popup-search.component.html',
    styleUrls: ['./common-popup-search.component.scss'],
    standalone: false
})
export class CommonPopupSearchComponent implements OnInit {

  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;
  hideOkButton: boolean =false;
  getdata: any = [];
  reportData: any;
  userid: any;
  fieldslist: any = {};

  backgroundColorButton = "";
  searchData;

  constructor(private commonService: CommonService, private snackbar: MatSnackBar, private constants: constants, public dialogref: MatDialogRef<CommonPopupSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData, private dropdownService: ReportingServiceService, private loginService: LoginService, private localStorageSettings: LocalStorageSettingsService) {
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: ActionCheckBox,
    }

    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
  }

  ngOnInit() {
console.log(this.data)
    console.log(this.constants.userid)
    this.columnDefs=this.generateColumns(this.data.columns)

    // this.columnDefs = [
    //   {
    //     headerName: 'Select',
    //     headerTooltip: 'Select',
    //     tooltipValueGetter: (params) => 'Select/Unselect',
    //     field: 'chckBox',
    //     filter: false,
    //     checkboxSelection: true,
    //     cellRendererParams: { refresh: this.selectAll.bind(this), },
    //     width: 120
    //   },
    //   {
    //     headerName: 'Dataset Name',
    //     headerTooltip: 'Dataset Name',
    //     tooltipValueGetter: (params) => 'Dataset Name: ' + params.value,
    //     field: 'datasetname',
    //     filter: 'agTextColumnFilter',
    //     width: 200
    //   },
    //   {
    //     headerName: 'Type',
    //     headerTooltip: 'Type',
    //     tooltipValueGetter: (params) => 'Access Type : ' + params.value,
    //     field: 'type',
    //     filter: 'agTextColumnFilter',
    //     width: 200
    //   },
    //   {
    //     headerName: 'Object Name',
    //     headerTooltip: 'Object Name',
    //     tooltipValueGetter: (params) => 'Object Name : ' + params.value,
    //     field: 'datasetObjectname',
    //     filter: 'agTextColumnFilter',
    //     width: 200
    //   },
    //   {
    //     headerName: 'Description',
    //     headerTooltip: 'Description',
    //     tooltipValueGetter: (params) => 'Description : ' + params.value,
    //     field: 'description',
    //     filter: 'agTextColumnFilter',
    //     width: 200
    //   },
    //   {
    //     headerName: 'Object Group',
    //     headerTooltip: 'Object Group',
    //     tooltipValueGetter: (params) => 'Object Group : ' + params.value,
    //     field: 'objectGroup',
    //     filter: 'agTextColumnFilter',
    //     width: 200
    //   },
    // ]



    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection =this.data.page;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    let res: any
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    console.log(this.constants.ReportCreation)
    console.log(this.constants.UserColoumns)
    console.log(this.constants.userid)
   // this.getdata = await this.commonService.retrieveRecordService(this.constants.ReportCreation);
    this.getdata = this.data.edata;

    // for (let i = 0; i < this.getdata.length; i++) {
    //   this.fieldslist = JSON.parse(this.getdata[i].fieldslist);
    //   //console.log(this.fieldslist["fieldListKeyName"]);
    //   this.getdata[i].fieldslist = this.fieldslist;
    // }
    console.log()
    this.gridAPI.setGridOption('rowData', this.getdata);
    if (this.getdata.objectid == "") {
      console.log("[[[[[[[[[[[[[[[[[")
      this.gridAPI.setGridOption('rowData', this.getdata);
      this.gridAPI.hideOverlay();
    }
    else {
      console.log("]]]]]]]]]]]]]]]]]]]]]")
      console.log(this.getdata);
      this.gridAPI.setGridOption('rowData', this.getdata);
      // this.gridAPI.forEachNode(node => {
      //   console.log("node data" + JSON.stringify(node.data))
      //   if (this.data.ObjectId == node.data.objectid) {
      //     node.setSelected(true);
      //   }
      // })
    }

for(let o=0;o<this.data.selectedValue.length;o++){
  console.log(this.data.selectedValue[o])
  this.gridAPI.forEachNode(node=>{
    console.log(node.data)
    if(this.data.selectedValue[o] && this.data.selectedValue[o].dnsType){
      if(node.data[this.data.selectedPropertyName]===this.data.selectedValue[o].objectname && node.data["dnsType"] == this.data.selectedValue[o].dnsType){
         node.setSelected(true)
    }
    }else if(this.data.selectedValue[o] && this.data.selectedValue[o].name && this.data.selectedValue[o].object){
      if(node.data['object']===this.data.selectedValue[o].object && node.data[this.data.selectedPropertyName] == this.data.selectedValue[o].name){
              node.setSelected(true)
          }
    }else if(this.data.selectedValue[o] && this.data.selectedValue[o].stageobject && this.data.selectedValue[o].targetobject){
       if(node.data[this.data.selectedPropertyName]===this.data.selectedValue[o].stageobject && node.data["targetobject"] == this.data.selectedValue[o].targetobject){
         node.setSelected(true)
    }
    }else{
      if(node.data[this.data.selectedPropertyName]===this.data.selectedValue[o]){
         node.setSelected(true)
      }
    }
  })
}
   
  }

  selectAll(e) {
    console.log(e)
    let d = {
      "userid": e.rowData.userid,
      "objectid": e.rowData.objectid,
      "datasetname": e.rowData.datasetname,
      "accesstype": e.rowData.accesstype,
      "fieldslist": e.rowData.fieldslist,
    }
    this.reportData = d
    console.log(this.reportData)
  }

  closePopup() {
    this.dialogref.close(null)
  }

  senddata() {
    var selectedRows = this.gridAPI.getSelectedRows();
    console.log(selectedRows);
    console.log(selectedRows[0]);
    let dataToSend ={
      selectedRows:selectedRows,
      searchData:this.searchData
    }
    this.dialogref.close(dataToSend);
  }

  onSelectionChanged() {
    var selectedRows = this.gridAPI.getSelectedRows();
    console.log(selectedRows);
    console.log(selectedRows[0]);
   // this.senddata(selectedRows[0]);
  }

  generateColumns(data: any[]) {

    console.log(data)
    let columnDefinitions = [];

    //creating the object for the action button
    let actionCol = {
          headerName: 'Select',
          headerTooltip: 'Select',
          tooltipValueGetter: (params) => 'Select/Unselect',
          field: 'chckBox',
          filter: false,
          checkboxSelection: true,
          cellRendererParams: { refresh: this.selectAll.bind(this), },
          width: 120
        }

      
 //Author Sujeet Sharma
//  @CreatedDate 12/02/2026
//   @Note Controls visibility of action column and OK button
//    based on hideCheckBox flag from dialog data.
//    If hideCheckBox is undefined or false, action column
//   is added and OK button is shown.
//  
        if(this.data.hideCheckBox == undefined || this.data.hideCheckBox == false){
            columnDefinitions.push(actionCol)
            this.hideOkButton = true;
        } else{
           this.hideOkButton = false;
        }
    

    //this is used to push all the keys and values present in the array
    data.map(object => {


      Object.keys(object).map(key => {
     console.log(object)
     console.log(key)
     console.log(object[key])

        if (key.indexOf('.') !== -1) {
          var k = key.split(".")
          console.log(k)
          var fieldValue = k[0] + " " + k[1]
          console.log(fieldValue)
          object[fieldValue] = object[key]
          let mappedColumn =
          {
            headerName: object[key],
            field: fieldValue,
            width: 180,
            filter: "agTextColumnFilter",
            suppressToolPanel: true,
           headerTooltip: object[key],
            tooltipValueGetter: (params) => {
            const value = params.value ? params.value.toString() : "";
            return params.colDef.headerName + " : " + value;
          },
                      align: 'center',

          }
          columnDefinitions.push(mappedColumn);
        } else {
          console.log(object[key])
          let mappedColumn2 =
          {
            headerName: object[key],
            field: key,
            width: 180,
            filter: "agTextColumnFilter",
            suppressToolPanel: true,
            headerTooltip: object[key],
                tooltipValueGetter: (params) => {
            const value = params.value ? params.value.toString() : "";
            return params.colDef.headerName + " : " + value;
          },
 
            align: 'center',

          }
          columnDefinitions.push(mappedColumn2);
        }

      })
    })

    console.log(columnDefinitions)
    //Remove duplicate columns
    //since we have pushed empId,empName,zoneId,employeezoneId these all are present in the ..
    //..array which is pushed by the mappedColumn  but we are also adding them externally 
    //..to avoid duplicates we are removing the duplicates here
    columnDefinitions = columnDefinitions.filter((column, index, self) =>
      index === self.findIndex((colAtIndex) => (
        colAtIndex.field === column.field
      ))
    )
    console.log(columnDefinitions)

    return columnDefinitions;
  }

  onQuickFilterChanged(event): void {
    console.log(event.target.value)
    this.searchData=event.target.value;
    this.gridAPI.setGridOption('quickFilterText',event.target.value)
  }

}
